import { render, staticRenderFns } from "./FinanceiroSidebar.vue?vue&type=template&id=6072a55e&"
import script from "./FinanceiroSidebar.vue?vue&type=script&lang=js&"
export * from "./FinanceiroSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports